module.exports = __webpack_public_path__ + "img/new-website-logo-light.2e6f13fe.png";